import React from 'react';
import { Box } from '@mui/material';
import { Navigate, useParams } from 'react-router-dom';
import { AI_APPS, aiAppUrl, ROUTES } from '../../consts';

const style = {
  container: {
    // Fill the viewport below the fixed AppBar (MUI default toolbar height).
    width: '100%',
    height: 'calc(100vh - 64px)',
    overflow: 'hidden',
  },
  frame: {
    width: '100%',
    height: '100%',
    border: 'none',
    display: 'block',
  },
} as const;

/**
 * Embeds an agent-native workspace app (Analytics, Clips, Content, Plan,
 * Dispatch) as a same-origin iframe served from /agents/<app>. Same-origin keeps
 * the embedded app's own auth session cookie first-party, so login works inside
 * the frame. `embedded=1` asks the app to drop its own top-level chrome.
 */
export const AiAppPage = (): JSX.Element => {
  const { app } = useParams<{ app: string }>();
  const entry = AI_APPS.find((a) => a.key === app);

  if (!entry) {
    return <Navigate to={ ROUTES.HOME } replace />;
  }

  // Enter at the app's concrete default route, not the bare base path (the
  // framework does not serve the index at the mounted base — see AI_APPS).
  const src = aiAppUrl(entry.key, true);

  return (
    <Box sx={ style.container }>
      <iframe
        key={ app }
        src={ src }
        title={ `ai-app-${app}` }
        style={ style.frame }
        allow="clipboard-read; clipboard-write; microphone; camera"
      />
    </Box>
  );
};

export default AiAppPage;
